import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { pushError } from '../reducers/game/game'
import { useSelector } from '../hooks/useSelector'
import { Card, CardProps } from '@prometheus/components'

export default ({ ignoreGameLogic, ...props }: CardProps & { ignoreGameLogic?: boolean, disabled?: boolean }) => {
  const [disabled, setDisabled] = useState(false)
  const playerChoosingPlanet = (useSelector(s => s.game.metadata?.players_choosing_planet) || []).length > 0 && !ignoreGameLogic
  const originalOnClick = props.onClick
  const dispatch = useDispatch()
  const onClick = useCallback(async (e) => {
    if (!originalOnClick) {
      return
    }
    setDisabled(true)
    try {
      await originalOnClick(e)
    } catch (e) {
      dispatch(pushError({
        type: 'error',
        message: (e as any).message,
      }))
    }
    setDisabled(false)
  }, [originalOnClick, dispatch])
  const isDisabled = props.disabled || disabled || playerChoosingPlanet;
  return <Card {...props} interactive={props.interactive && !isDisabled} onClick={isDisabled ? undefined : onClick} />
}
